import { Layer } from "react-map-gl";
import { hexToHSL } from "../layer-utils";
import { useEffect, useState } from "react";
import { LayerProps } from "../explorer-display-layers";
import { HSLToHSLString, highlightTypeForGeo } from "./paint";
import { highlightPaintForGeo } from "./paint";
import useDarkMode from "use-dark-mode";

export function PrimaryHighlightLayer(props: LayerProps) {
  const { value: isDark } = useDarkMode();

  return (
    <Layer
      key={props.id}
      layout={{
        visibility: props.layerConfig.visible ? "visible" : "none",
      }}
      beforeId={props.beforeId ?? ""}
      id={props.id}
      type={highlightTypeForGeo(props.layer.geometry)}
      source={props.source.description}
      source-layer={props.layer.id}
      paint={highlightPaintForGeo(
        isDark ? "#EEEEEE" : "#616161",
        1,
        props.layer.geometry,
        3
      )}
      //@ts-ignore
      filter={props.layerConfig.primaryHighlightsFilter}
    />
  );
}
